'use client';

import { useEffect } from 'react';
import Page from '@organisms/Page/Page';
import useCmsPage from '@hooks/useCmsPage';
import ErrorComponent from '@molecules/ErrorComponent/ErrorComponent';
import { CategoryProvider } from '@root/contexts/CategoryContext';
import CategoryPageSkeleton from './CategoryPageSkeleton';

interface Props {
  code: string;
}

const CategoryPageClient = ({ code }: Props) => {
  const { cmsPage, error, isLoading } = useCmsPage(undefined, 'CategoryPage', code);

  useEffect(() => {
    if (!cmsPage?.seoTitle) return;
    document.title = cmsPage.seoTitle;
    if (cmsPage.seoDescription) {
      document.querySelector('meta[name="description"]')?.setAttribute('content', cmsPage.seoDescription);
    }
  }, [cmsPage?.seoTitle, cmsPage?.seoDescription]);

  if (!isLoading && error) return <ErrorComponent errorCode={404} />;
  // useCmsPage only picks up the server-fetched page on its first render (see makeCmsPageFallbackKey).
  // After a client-side navigation it refetches in the browser, so show the route's skeleton meanwhile
  // instead of an empty page.
  if (!cmsPage) return <CategoryPageSkeleton />;
  return (
    <CategoryProvider categoryCode={code}>
      <Page cmsPage={cmsPage} />
    </CategoryProvider>
  );
};

export default CategoryPageClient;
